module.exports = __webpack_public_path__ + "img/five4Red.fc812d0b.jpg";